import actionTypes from '../../actions/dictionaries/dictionaries.action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_OUTLET_TYPES_DICTIONARY_SUCCESS:
      return { ...action.outletTypes };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/modules/app/reducers/dictionaries/outlet-types-dictionary.js